<template>
    <v-card
        class="mx-auto"
        max-width="500"
        outlined
        elevation="2"
        color="rgba(255, 255, 255, 0.9)"
    >
        <v-form @submit.prevent="submit">
            <v-card-title class="justify-center">{{ $t('views.auth.login.login') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-text-field
                    v-model="form.email"
                    :label="$t('views.auth.login.email_label')"
                    :error="$store.getters.hasValidationError('email')"
                    :error-messages="$store.getters.validationError('email')"
                ></v-text-field>

                <v-text-field
                    v-model="form.password"
                    :label="$t('views.auth.login.password_label')"
                    :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordVisible ? 'text' : 'password'"
                    @click:append="passwordVisible = !passwordVisible"
                    :error="$store.getters.hasValidationError('password')"
                    :error-messages="$store.getters.validationError('password')"
                ></v-text-field>

            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn
                    rounded
                    type="submit"
                    color="success"
                    :loading="loggingIn"
                    block
                >{{ $t('views.auth.login.login_button') }}</v-btn>
            </v-card-actions>

            <v-card-text class="text-center">
                <router-link :to="{name: 'register'}">
                    {{ $t('views.auth.login.register_link') }}
                </router-link>
                |
                <router-link :to="{name: 'forgot_password'}">
                    {{ $t('views.auth.login.password_recovery_link') }}
                </router-link>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
import {Auth} from "../../modules/utils";

export default {
        name: "Login",

        data() {
            return {
                passwordVisible: false,
                loggingIn: false,

                form: {
                    email: null,
                    password: null,
                }
            };
        },

        methods: {
            submit: function() {

                if(this.loggingIn) {
                    return;
                }

                this.loggingIn = true;

                this.$store.dispatch('login', this.form)
                    .then(response => {
                        if(response.status !== 200) {
                            this.$store.commit(
                                "showSnackbarError",
                                this.$t('views.auth.login.login_failed')
                            );
                            return;
                        }

                        Auth.authenticate();
                        // noinspection JSUnresolvedVariable
                        Auth.verify(response.data.verified);
                        // noinspection JSUnresolvedVariable
                        if(response.data.is_administrator === true) {
                            Auth.actAsAdministrator();
                        }
                        let redirect = this.$route.query.redirect;
                        this.$router.push(redirect ? {path: redirect} : {name: 'orders'}).catch(() => {});
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loggingIn = false;
                });
            },
        },
    }
</script>

<style scoped>

</style>
